import { StoreAction, XmAction } from 'store/actions';
import { planEligibilityDetails } from './models';
import { targetPlanSwitchDetails } from './models/target-plan-switch';
import { PlanSwitchOrderReview } from './models/order-review';

export function planEligibilityDetailsReducer(state: planEligibilityDetails, action: XmAction<planEligibilityDetails>): planEligibilityDetails {
    switch (action.type) {
        case StoreAction.GET_PLAN_ELIGIBILITY:
        case StoreAction.GET_PLAN_EIGHT_ELIGIBILITY:
        case StoreAction.GET_CBM_PLAN_ELIGIBILITY:
            return action.payload;
        default:
            return state;
    }
}

export function targetPlanSwitchDetailsReducer(state: targetPlanSwitchDetails, action: XmAction<targetPlanSwitchDetails>): targetPlanSwitchDetails {
    switch (action.type) {
        case StoreAction.GET_TARGET_PLAN_UNL_SWITCH:
        case StoreAction.GET_TARGET_PLAN_BTG_SWITCH:
        case StoreAction.GET_TARGET_PLAN_LEGACY_UNL_SWITCH:
        case StoreAction.GET_TARGET_PLAN_LEGACY_BTG_SWITCH:
        case StoreAction.GET_TARGET_PLAN_8_SWITCH:
        case StoreAction.GET_TARGET_PLAN_SWITCH_CBM:
            return action.payload;
        default:
            return state;
    }
}

export function planSwitchOrderReviewReducer(state: PlanSwitchOrderReview, action: XmAction<PlanSwitchOrderReview>): PlanSwitchOrderReview {
    if (action.type === StoreAction.POST_PLAN_SWITCH_ORDER_REVIEW) {
        return action.payload;
    }

    return state;
}
